import apis from "../common/apis";
import { IResponse } from "../models";
import { IFilterOptionProps } from "../models/interface";
import { HTTP_METHOD_GET } from "../utils/constant";
import { callApi } from "./fetchTools";

export default {
  getFilterOptions: (query: IFilterOptionProps) => {
    return callApi<IResponse<any[]>>(
      HTTP_METHOD_GET,
      apis.public_filter_options,
      query
    );
  },
  getFilterOptionChilds: (query: any) => {
    return callApi<IResponse<any[]>>(
      HTTP_METHOD_GET,
      apis.public_filter_option_childs,
      query
    );
  },
  getFilterOptionChild: (params: any) => {
    return callApi<IResponse<any[]>>(
      HTTP_METHOD_GET,
      `${apis.public_filter_option_childs}${params.filter_option_parent_id}/${params.category_ids}`,
      null
    );
  },
};
